<h1 mat-dialog-title>Scegli il file</h1>
<input type="file"
       id="file"
       (change)="processaFile($event.target.files)">
<div mat-dialog-actions>
<span id="formButton" *ngIf="fileToUpload != undefined">
  <button style="display: inline; margin: 10px" mat-button color="primary"
          (click)="upload()">Invia</button>
  <button style="display: inline; margin: 10px" mat-button color="warn"
          (click)="cancel()">Annulla</button>
</span>
</div>
